import {getpermission} from '../../api/index'
import router,{DynamicRoutes} from '../../router/index'
import dynamicRouter from '../../router/dynamice-router'
import {recursionRouter,setDefaultRoute} from '../../utils/recursion-router'
import store from '../../store/index'
import qs from 'qs'
export default{
  namespaced:true,
  state:{
    permissionList:null,
    sidebarMenu:[],// 导航菜单
    currentMenu:'', // 高亮
  },
  getters:{},
  mutations:{
      SET_PERMISSION(state,routes){
          state.permissionList = routes;
      },
      CLEAR_PERMSSION(state){
          state.permissionList = null;
      },
      SET_MENU(state,menu){
          state.sidebarMenu = menu;
      },
      CLEAR_MENU(state){
          state.sidebarMenu = []
      }
  },
  // 异步访问
  actions:{
    async FETCH_PERMISSION({ commit,state }){
        console.log(store.state)
        let app=qs.stringify({
            username:store.state.UserName,
            usertoken:store.state.UserToken
        })
        let permissionList= await getpermission(app)
        console.log(permissionList,store)
        // 筛选
        if(permissionList.data.code=='1200'){
            console.log('token过期',store)
            store.commit('LOGIN_OUT')
            this.$router.push('login')
        }
        let routes = recursionRouter(permissionList.data.permission,dynamicRouter);
        // console.log(routes)
        let MainContainer = DynamicRoutes.find(v => v.path === "/home");
        let children = MainContainer.children;
        children.push(...routes)
        
        // 生成菜单
        commit("SET_MENU",children);

        // 设置默认路由
        // console.log(MainContainer.children[0])
        // let son=MainContainer.children
        setDefaultRoute([MainContainer]);
        // 初始化路由
        let initialRoutes = router.options.routes;
        // console.log(initialRoutes,DynamicRoutes)
        router.addRoutes(DynamicRoutes);
        commit("SET_PERMISSION",[ ...initialRoutes , ...DynamicRoutes])
    }
}
}